module.exports = __webpack_public_path__ + "static/media/Chris.3a064fe2.jpg";